import { getCookie } from "./cookie";

let publicToken: string | null = null;

/**
 * Fetches the `access_token` cookie and caches it in memory.
 *
 * @returns The `access_token` value or `'none'` if not set.
 */
export function getPublicToken(): string {
    if (!publicToken) {
        publicToken = getCookie("access_token") || "none";
    }

    return publicToken;
}
